import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
const stripePromise = loadStripe('pk_test_51PLs2IRphVq07dqXa854mYczJjULhy3zeIBZMxPHXTqBqVuvSReg33ya4lDlrR760u6b9TWIc6xVJPrXSyADdZ9c00wQF1q7Ja');
const StripeWrapper = ({ children }) => {
    return (
        <Elements stripe={stripePromise} options={{
            appearance: { theme: "stripe" },
        }}>
            {children}
        </Elements>
    );
};
export default StripeWrapper;